export default __webpack_public_path__ + "./images/gr.715c6cfa.png";